import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { WixIcons } from '../../../../components/common';
import styles from '../EmptyState.scss';
import { IOuter } from '../EmptyState.types';

export const BoardSubtitle: FC<IOuter> = () => (
  <FormattedMessage
    id="empty-state.board.subtitle"
    values={{ addToBoardIcon: <WixIcons.Bookmark className={styles.favoritesStarIcon} /> }}
  />
);
